define( function() {
	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/css/var/cssExpand.js
// module id = 863
// module chunks = 0